import { Component, HostBinding, Input } from '@angular/core'

/** The #111316 band at the top of Time & Pay and Help screens. Right-hand content goes in `<x rtHeroAside>`. */
@Component({
  selector: 'rt-hero',
  template: `
    <section class="rt-hero">
      <div class="rt-hero__inner">
        <div class="rt-hero__text">
          <p class="rt-eyebrow">{{ kicker }}</p>
          <h1 class="rt-hero__title">{{ title }}</h1>
          <p *ngIf="sub" class="rt-hero__sub">{{ sub }}</p>
        </div>
        <ng-content select="[rtHeroAside]"></ng-content>
      </div>
    </section>`,
})
export class RtHeroComponent {
  @Input() kicker = ''
  @Input() title = ''
  @Input() sub: string | null = null
  // `title` is also a global attribute; without this the whole band shows it as a tooltip.
  @HostBinding('attr.title') readonly hostTitle = null
}
